import { Component, OnInit } from '@angular/core';
import { ProductosService } from 'src/app/services/productos.service';
import Swal from 'sweetalert2';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-administracion',
  templateUrl: './administracion.component.html',
  styleUrls: ['./administracion.component.scss']
})
export class AdministracionComponent implements OnInit {

  pendientes: any;
  pend: any;
  envio = [];
  carrito: any;
  subtotal: number;
  descuento: number;
  total: number;
  fecha: number;
  comprador: string;
  idCliente: string;
  cliente: any;
  cedula: string;
  direccion: string;
  ciudad: string;
  estado: string;
  email: string;
  telefono: string;
  tipo: string;
  idPedido: string;
  cont = 0;
  constructor(private prodSvc: ProductosService,
              private authSvc: AuthService) { }

  ngOnInit(): void {
    this.filtrarPedidos();
  }

  filtrarPedidos(){
    this.prodSvc.cargarPedidosPendientes()
                .subscribe(res => {
                  this.pendientes = res;
                  this.pend = res;
                  this.cont = res.length;
                  this.pendientes.sort((a, b) => {
                    if (a.fecha < b.fecha) {
                      return 1;
                    }
                    if (a.fecha > b.fecha) {
                      return -1;
                    }
                  });
                });
  }

  detalle(lista: any){
    console.log(lista);
    this.carrito = lista.carrito;
    this.subtotal = lista.subtotal;
    this.descuento = lista.descuento;
    this.total = lista.total;
    this.fecha = lista.fecha;
    this.comprador = lista.nombre;
    this.email = lista.email;
    this.telefono = lista.telefono;
    this.tipo = lista.tipo;
    this.idPedido = lista.id;
    this.estado = lista.estado;
    this.idCliente = lista.cliente;
    this.direccion = lista.direccion;
    this.ciudad = lista.ciudad;
    this.cedula = lista.cedula;    
  }

  aceptarPedido(){
    Swal.fire({
      title: 'Está Seguro?',
      text: 'El pedido va ha ser aceptado y cambia de estado: EN ENVÍO',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, aceptar!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.prodSvc.aceptarPedido(this.idPedido);
        Swal.fire(
          'Aceptado!',
          'Pedido en proceso de envío.',
          'success'
        );
      }
    });
  }

  cancelarPedido(){
    Swal.fire({
      title: 'Está Seguro?',
      text: 'El pedido va ha ser cancelado',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, aceptar!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.prodSvc.cancelarPedido(this.idPedido);
        Swal.fire(
          'Cancelado!',
          'Pedido ha sido cancelado.',
          'success'
        );
      }
    });
  }

  cancelarPedidoTabla(idPedido: string){
    Swal.fire({
      title: 'Está Seguro?',
      text: 'El pedido va ha ser cancelado',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, aceptar!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.prodSvc.cancelarPedido(idPedido);
        Swal.fire(
          'Cancelado!',
          'Pedido ha sido cancelado.',
          'success'
        );
      }
    });
  }


  filtrar(event: string){    
    if (event === 'aceptados') {
      this.pendientes = [];
      this.prodSvc.cargarPedidosAceptados()
      .subscribe(res => {
        this.pendientes = res;
        this.pendientes.sort((a, b) => {
          if (a.fecha < b.fecha) {
            return 1;
          }
          if (a.fecha > b.fecha) {
            return -1;
          }
        });
      });
    }
    if (event === 'cancelados') {
      this.pendientes = [];
      this.prodSvc.cargarPedidosCancelados()
      .subscribe(res => {
        this.pendientes = res;
        this.pendientes.sort((a, b) => {
          if (a.fecha < b.fecha) {
            return 1;
          }
          if (a.fecha > b.fecha) {
            return -1;
          }
        });
      });
    }
    if (event === 'pendientes') {
      this.pendientes = this.pend;
      this.pendientes.sort((a, b) => {
        if (a.fecha < b.fecha) {
          return 1;
        }
        if (a.fecha > b.fecha) {
          return -1;
        }
      });
    }
  }

}
